/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Job_LabelInputs */

const en_deep_match_job_label = /** @type {(inputs: Deep_Match_Job_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const de_deep_match_job_label = /** @type {(inputs: Deep_Match_Job_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const fr_deep_match_job_label = /** @type {(inputs: Deep_Match_Job_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const es_deep_match_job_label = /** @type {(inputs: Deep_Match_Job_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const it_deep_match_job_label = /** @type {(inputs: Deep_Match_Job_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const nl_deep_match_job_label = /** @type {(inputs: Deep_Match_Job_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const pl_deep_match_job_label = /** @type {(inputs: Deep_Match_Job_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const fi_deep_match_job_label = /** @type {(inputs: Deep_Match_Job_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const da_deep_match_job_label = /** @type {(inputs: Deep_Match_Job_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const sv_deep_match_job_label = /** @type {(inputs: Deep_Match_Job_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

/**
* | output |
* | --- |
* | "Job" |
*
* @param {Deep_Match_Job_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_job_label = /** @type {((inputs?: Deep_Match_Job_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Job_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_job_label(inputs)
	if (locale === "fr") return fr_deep_match_job_label(inputs)
	if (locale === "es") return es_deep_match_job_label(inputs)
	if (locale === "it") return it_deep_match_job_label(inputs)
	if (locale === "nl") return nl_deep_match_job_label(inputs)
	if (locale === "pl") return pl_deep_match_job_label(inputs)
	if (locale === "fi") return fi_deep_match_job_label(inputs)
	if (locale === "da") return da_deep_match_job_label(inputs)
	if (locale === "sv") return sv_deep_match_job_label(inputs)
	return en_deep_match_job_label(inputs)
});